import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

interface MonthItem {
  value: number;
  name: string;
  checked: boolean;
}

@Component({
  selector: 'app-period-picker',
  templateUrl: './period-picker.component.html',
  styleUrls: ['./period-picker.component.scss'],
})
export class PeriodPickerComponent implements OnInit, OnChanges {
  @Input() id: string = '';
  @Input() label: string = 'INSTALLATIONS.INVOICE.PERIOD';
  @Input() initialYear?: number;
  @Input() initialMonths: number[] = [];
  @Input() minYear?: number;
  @Input() maxYear?: number;

  @Output() apply = new EventEmitter<{ year: number; months: number[] }>();

  year: number = new Date().getFullYear();
  months: MonthItem[] = [];
  summary: string = '';
  opened: boolean = false;

  private static readonly MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    this.year = this.initialYear ?? new Date().getFullYear();
    this.months = PeriodPickerComponent.MONTH_NAMES.map((name, i) => ({
      value: i + 1,
      name,
      checked: this.initialMonths.includes(i + 1),
    }));
    this.updateSummary();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['initialMonths'] && this.months.length) {
      this.months.forEach((m) => (m.checked = (this.initialMonths ?? []).includes(m.value)));
      this.updateSummary();
    }
    if (changes['initialYear'] && this.initialYear != null) {
      this.year = this.initialYear;
      this.updateSummary();
    }
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.el.nativeElement.contains(event.target)) this.opened = false;
  }

  toggle() {
    this.opened = !this.opened;
  }

  incrementYear() {
    if (this.maxYear == null || this.year < this.maxYear) this.year++;
  }

  decrementYear() {
    if (this.minYear == null || this.year > this.minYear) this.year--;
  }

  onApply() {
    const selected = this.months.filter((m) => m.checked).map((m) => m.value);
    this.updateSummary();
    this.opened = false;
    this.apply.emit({ year: this.year, months: selected });
  }

  private updateSummary() {
    const checked = this.months.filter((m) => m.checked).map((m) => m.name.substring(0, 3));
    this.summary = checked.length > 0 ? `${checked.join(', ')} ${this.year}` : '';
  }
}
